import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';

import {
  PageTitleAndSubTitle,
  valueWithText,
  BudgetChart,
  // ClaimsStatusDistribution,
  PieChart,
  OverviewCard,
  Breadcrumbs,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../../core-utils/properties';

import planPerformanceMetricsMessages from '../../core-utils/helper-utils/planPerformanceMetricsMessages';
import axios from 'axios';
import { BudgetData } from '../../core-utils/helper-utils/budgetDataHelper';
import { TotalMedicalCostData } from '../../core-utils/helper-utils/totalMedicalCostHelper';
// import { ClaimStatusDistribution } from '../../core-utils/helper-utils/claimStatusDistribution';
import Loader from '../../_components/molecules/Loader';
import TotalMedicalCost from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/TotalMedicalCost';
import { networkLeakagePageConstants } from '../NetworkLeakagePage/networkLeakageConstants';
import { formatDate } from '../../core-utils/helper-utils/helper';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  // formatPEPM,
  // formatPMPM,
  formatTotalCost,
  formatTotalEnrolled,
  // getPepmForCohorts,
  // getPepmValueForCohorts,
  // getPmpmForCohorts,
  // getPmpmValueForCohorts,
  // PEPM,
  // PMPM,
  TotalCost,
  TotalEnrolled,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { AmountRatioAPIResponse } from '../../core-utils/helper-utils/networkLeakageHelpers';
import { pageScrollDown } from '../SummaryPage';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CLAIMS_METRICS,
  ENROLLMENT_METRICS,
  NETWORK_LEAKAGE,
  PLAN_PERFORMANCE,
  // REJECTED_CLAIMS,
} from '../../core-utils/routes';
import networkLeakage from '../../core-utils/messages/networkLeakage';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsDataForUtilizationMetrics } from '../../core-utils/helper-utils/recommendationsTabHelper';
import enrollmentMetricsMessages from '../../core-utils/messages/enrollmentMetricsMessages';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import { observer } from 'mobx-react';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

const PlanPerformance = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
    GridItem: {
      marginBottom: '27px',
      display: 'inline-block',
    },
    box: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      background: 'white',
      border: '1px solid grey}',

      width: '1175px',
      height: '388px',
    },
  });
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  const pageConstants = componentConstants.PAGES.PLAN_PERFORMANCE_METRICS_PAGE;
  const [budgetActualData, setbudgetActualData] = useState<BudgetData>();
  // const [claimStatusData, setClaimStatusData] = useState<
  //   ClaimStatusDistribution[]
  // >();
  const [networkData, setNetworkData] = useState<AmountRatioAPIResponse[]>([]);
  const [
    totalMedicalCostData,
    setTotalMedicalCostData,
  ] = useState<TotalMedicalCostData>();

  const [loading, setLoading] = useState<boolean>(false);
  const [costTrendLoading, setCostTrendLoading] = useState<boolean>(false);
  const [diagnosisType, setDiagnosisType] = useState<string>('Medical Cost');
  // const [plans, setPlans] = useState<string[]>([]);

  const [totalEligible, setTotalEligible] = useState<number>(0);

  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    totalCount: '',
    dependents: '',
    employees: '',
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  // const [pmpm, setPMPM] = useState<PMPM>({
  //   pmpm: '',
  //   pmpmPercentage: '',
  //   increment: true,
  // });
  // const [pepm, setPEPM] = useState<PEPM>({
  //   pepm: '',
  //   pepmPercentage: '',
  //   increment: true,
  // });
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  ); //snackbar
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsDataForUtilizationMetrics(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        [
          componentConstants.PAGES.CLAIM_METRICS_PAGE.TITLE,
          enrollmentMetricsMessages.pageTitles.title,
          networkLeakage.titleAndSubtitle.title,
          planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
            .titleAndSubtitle.title,
          planPerformanceMetricsMessages.pendingClaims,
        ],
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const getTotalEligible = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          claim_id_list: [],
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setTotalEligible(res?.data?.data?.totalEligibleCount);
          setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
          setTotalCost(formatTotalCost(res?.data?.data));
        }
      })
      .catch(() => {});
  };

  // const getTotalCost = async () => {
  //   await axios
  //     .post(
  //       properties.aiqBaseUrl +
  //         properties.summaryBaseUrl +
  //         properties.totalPlanPaid,
  //       {
  //         ...payload,
  //         claim_id_list: [],
  //         member_unique_id_list: [],
  //       },
  //       { signal: abortController.signal },
  //     )
  //     .then((res) => {
  //       if (res?.status === 200) {
  //         setTotalCost(formatTotalCost(res?.data?.data));
  //       }
  //     })
  //     .catch(() => {});
  // };

  // const getPMPMAndPepm = async () => {
  //   await axios
  //     .post(
  //       properties.aiqBaseUrl +
  //         properties.summaryBaseUrl +
  //         properties.pmpmAndPepm,
  //       {
  //         startDate:
  //           aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
  //         endDate:
  //           aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
  //         eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
  //         member_unique_id_list: [],
  //         max_claim_date:
  //           employerGroupStore?.employerGroupResponseData?.max_claim_date,
  //       },
  //       { signal: abortController.signal },
  //     )
  //     .then((res) => {
  //       if (res?.status === 200) {
  //         setPMPM(formatPMPM(res?.data?.data?.pmpm));
  //         setPEPM(formatPEPM(res?.data?.data?.pepm));
  //       }
  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // };

  const getActualandBudgetData = async () => {
    const baseUrl = properties.aiqBaseUrl + properties.getBudget;

    const requestBody = {
      ...payload,
      claim_id_list: [],
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      maxClaimDate:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };

    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setbudgetActualData(res.data?.data);
        }
      })
      .catch(() => {});
  };
  const apiCalls = async () => {
    getActualandBudgetData();
  };

  // const getCostDistribution = async () => {
  //   const baseUrl = properties.aiqBaseUrl + properties.getCostDistribution;

  //   const requestBody = {
  //     ...payload,
  //   };

  //   await axios
  //     .post(baseUrl, requestBody, { signal: abortController.signal })
  //     .then((res) => {
  //       if (res) {
  //         setClaimCostData(res.data?.data);
  //       }
  //     })
  //     .catch(() => {});
  // };
  const getNetworkData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.networkBaseUrl +
      properties.amountRatio;

    const requestBody = {
      ...payload,
      network_indicator:
        employerGroupStore.employerGroupResponseData.network_indicator_list,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };

    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        setNetworkData(res.data?.data);
      })
      .catch(() => {});
  };

  // const getClaimsStatusDistribution = async () => {
  //   const baseUrl =
  //     properties.aiqBaseUrl + properties.getClaimsStatusDistribution;

  //   const requestBody = {
  //     startDate:
  //       aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
  //     endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
  //     eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
  //   };

  //   await axios
  //     .post(baseUrl, requestBody, { signal: abortController.signal })
  //     .then((res) => {
  //       if (res) {
  //         setClaimStatusData(res.data?.data);
  //         setPlans(res.data?.data.map((plan: any) => plan.plan));
  //       }
  //     })
  //     .catch(() => {});
  // };
  // const apiCallsForClaimDistribution = async () => {
  //   getClaimsStatusDistribution();
  // };
  // const apiCallsForCostDistribution = async () => {
  //   getCostDistribution();
  // };
  const apiCallsForNetwork = async () => {
    getNetworkData();
  };
  const getTotalMedicalCostDistribution = async (value: string) => {
    const baseUrl =
      properties.aiqBaseUrl + properties.getTotalMedicalCostDistribution;
    let data;
    if (value === 'Rx Cost') {
      data = 'rx';
    } else if (value === 'Medical Cost') {
      data = 'medical';
    }
    const requestBody = {
      ...payload,
      claimType: data,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };

    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setTotalMedicalCostData(res.data?.data);
        }
      })
      .catch(() => {});
  };
  const apiCallsForTotalMedicalCostDistribution = async (type: string) => {
    await getTotalMedicalCostDistribution(type);
  };

  // const getReversedData = () => {
  //   const reversedData: any = [];
  //   claimStatusData?.forEach((item) => {
  //     const data = {
  //       value: item.Reversed,
  //     };
  //     reversedData.push(data);
  //   });
  //   return reversedData;
  // };

  // const getRejectedData = () => {
  //   const rejectedData: any = [];
  //   claimStatusData?.forEach((item) => {
  //     const data = {
  //       value: item.Rejected,
  //     };
  //     rejectedData.push(data);
  //   });
  //   return rejectedData;
  // };

  // const getProcessedData = () => {
  //   const processedData: any = [];
  //   claimStatusData?.forEach((item) => {
  //     const data = {
  //       value: item.Processed,
  //     };

  //     processedData.push(data);
  //   });
  //   return processedData;
  // };

  // const getCostDistrbutionChartData = () => {
  //   const array = [];

  //   const totalCost =
  //     claimCostData?.medical_total_charge === undefined
  //       ? 0
  //       : claimCostData?.medical_total_charge +
  //           claimCostData?.rx_total_charge ===
  //         undefined
  //       ? 0
  //       : claimCostData?.rx_total_charge;

  //   array.push({
  //     id: 'Flare',
  //     parent: '',
  //     label: 'Total Cost',
  //     value: totalCost,
  //     color: '#FFFFFF',
  //   });

  //   if (
  //     claimCostData?.medical_total_charge !== undefined &&
  //     claimCostData?.medical_total_charge !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical Total charge',
  //       parent: 'Flare',
  //       label: 'Medical Cost',
  //       color: '#475CB0',
  //       value: claimCostData?.medical_total_charge,
  //     });
  //   }

  //   if (
  //     claimCostData?.rx_total_charge !== undefined &&
  //     claimCostData?.rx_total_charge !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx Total charge',
  //       parent: 'Flare',
  //       label: 'Rx Cost',
  //       value: claimCostData?.rx_total_charge,
  //       color: '#F77328',
  //     });
  //   }
  //   if (
  //     claimCostData?.medical_plan_paid !== undefined &&
  //     claimCostData?.medical_plan_paid !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical Plan paid',
  //       parent: 'Medical Total charge',
  //       label: 'Medical Plan paid',
  //       value: claimCostData?.medical_plan_paid,
  //       color: '#919DD0',
  //     });
  //   }
  //   if (
  //     claimCostData?.medical_member_paid !== undefined &&
  //     claimCostData?.medical_member_paid !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical Member paid',
  //       parent: 'Medical Total charge',
  //       label: 'Medical Member paid',
  //       value: claimCostData?.medical_member_paid,
  //       color: '#6C7DC0',
  //     });
  //   }

  //   if (
  //     claimCostData?.rx_plan_paid !== undefined &&
  //     claimCostData?.rx_plan_paid !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx Plan paid',
  //       parent: 'Rx Total charge',
  //       label: 'Rx Plan paid',
  //       value: claimCostData?.rx_plan_paid,
  //       color: '#FF8850',
  //     });
  //   }

  //   if (
  //     claimCostData?.rx_member_paid !== undefined &&
  //     claimCostData?.rx_member_paid !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx Member paid',
  //       parent: 'Rx Total charge',
  //       label: 'Rx Member paid',
  //       value: claimCostData?.rx_member_paid,
  //       color: '#F5945D',
  //     });
  //   }

  //   if (
  //     claimCostData?.medical_deductible !== undefined &&
  //     claimCostData?.medical_deductible !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical deductible',
  //       parent: 'Medical Member paid',
  //       label: 'Medical deductible',
  //       value: claimCostData?.medical_deductible,
  //       color: '#B5BEDF',
  //     });
  //   }

  //   if (
  //     claimCostData?.medical_copay !== undefined &&
  //     claimCostData?.medical_copay !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical copay',
  //       parent: 'Medical Member paid',
  //       label: 'Medical copay',
  //       value: claimCostData?.medical_copay,
  //       color: '#DADEEF',
  //     });
  //   }

  //   if (
  //     claimCostData?.medical_coinsurance !== undefined &&
  //     claimCostData?.medical_coinsurance !== 0
  //   ) {
  //     array.push({
  //       id: 'Medical coinsurance',
  //       parent: 'Medical Member paid',
  //       label: 'Medical coinsurance',
  //       value: claimCostData?.medical_coinsurance,
  //       color: '#EDEFF4',
  //     });
  //   }

  //   if (
  //     claimCostData?.rx_deductible !== undefined &&
  //     claimCostData?.rx_deductible !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx deductible',
  //       parent: 'Rx Member paid',
  //       label: 'Rx deductible',
  //       value: claimCostData?.rx_deductible,
  //       color: '#FFB48F',
  //     });
  //   }

  //   if (
  //     claimCostData?.rx_copay !== undefined &&
  //     claimCostData?.rx_copay !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx copay',
  //       parent: 'Rx Member paid',
  //       label: 'Rx copay',
  //       value: claimCostData?.rx_copay,
  //       color: '#FFC2A5',
  //     });
  //   }
  //   if (
  //     claimCostData?.rx_coinsurance !== undefined &&
  //     claimCostData?.rx_coinsurance !== 0
  //   ) {
  //     array.push({
  //       id: 'Rx coinsurance',
  //       parent: 'Rx Member paid',
  //       label: 'Rx coinsurance',
  //       value: claimCostData?.rx_coinsurance,
  //       color: '#FFEAE0',
  //     });
  //   }

  //   return array;
  // };

  const {
    employerGroupStore,
    loginPageStore,
    cohortDetailsStore,
  } = useStores();
  const recommendedTabStore = useStores().recommendedTabStore;

  const getAPICalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getTotalEligible(),
        // getTotalCost(),
        // apiCallsForCostDistribution(),
        apiCalls(),
        apiCallsForTotalMedicalCostDistribution(diagnosisType),
        // apiCallsForClaimDistribution(),
        apiCallsForNetwork(),
      ]).then(() => {
        setLoading(false);
      }));

    setLoading(false);
  };

  const getAPICallForCostTrending = async (type: string) => {
    isPlanDatesFetched &&
      (await Promise.all([apiCallsForTotalMedicalCostDistribution(type)]).then(
        () => {
          setCostTrendLoading(false);
        },
      ));
    setCostTrendLoading(false);
  };
  // Edit duration related states and functions

  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getAPICalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const handleRadioButton = (event: any) => {
    setCostTrendLoading(true);
    setDiagnosisType(event.target.value);
    getAPICallForCostTrending(event.target.value);
  };

  const getMedicalCost = () => {
    const medicalCost: any = [];

    totalMedicalCostData?.costTrend.forEach((item) => {
      const med = getMonth(item.month) + ' ' + item.year;

      const data = { label: med, value: item.total_cost };
      medicalCost.push(data);
    });
    return medicalCost;
  };
  const getMonth = (month: number) => {
    switch (month) {
      case 1:
        return 'Jan';
      case 2:
        return 'Feb';
      case 3:
        return 'Mar';
      case 4:
        return 'Apr';
      case 5:
        return 'May';
      case 6:
        return 'Jun';
      case 7:
        return 'Jul';
      case 8:
        return 'Aug';
      case 9:
        return 'Sep';
      case 10:
        return 'Oct';
      case 11:
        return 'Nov';
      case 12:
        return 'Dec';
      default:
        return 'Invalid';
    }
  };

  const legend = [
    {
      label: 'Medical Cost',
      color: '#475CB0',
    },
    {
      label: 'Rx Cost',
      color: '#FF8E59',
    },
  ];
  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      const cleanSummaryData = {
        totalEligible,
        totalEnrolled,
        totalCost,
      };

      const cleanBudgetData = {
        budgetActualData,
      };

      const cleanNetworkData = {
        networkData,
      };

      const cleanMedicalCostTrend = {
        totalMedicalCostData,
      };

      const apiResponses = {
        title_1: cleanSummaryData,
        title_2: cleanBudgetData,
        title_3: cleanNetworkData,
        title_4: cleanMedicalCostTrend,
      };

      let resultArray = [];

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.PLAN_PERFORMANCE, // ✅ define this constant
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);
      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };
  //click Here Navigation Functions -
  const pushToEnrollemntMetrics = () => {
    navigate(ENROLLMENT_METRICS);
  };

  const costTrendByMonth = () => {
    if (pathStore.path.length !== 0) {
      pathStore.setPath([
        pathStore.path[0],
        [
          'text',
          planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            pathStore.path.pop();
            pathStore.path[pathStore.path.length - 1][2] = {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            };
            pathStore.path[pathStore.path.length - 1][3] = null;
            navigate(PLAN_PERFORMANCE);
          },
        ],
        [
          'text',
          componentConstants.PAGES.CLAIM_METRICS_PAGE.TITLE,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ]);

      navigate(CLAIMS_METRICS);
    } else {
      pathStore.setPath([
        [
          'text',
          planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            pathStore.clearPath();
            navigate(PLAN_PERFORMANCE);
          },
        ],
        [
          'text',
          componentConstants.PAGES.CLAIM_METRICS_PAGE.TITLE,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ]);
      navigate(CLAIMS_METRICS);
    }
  };
  const networkLeakageImpact = () => {
    if (pathStore.path.length !== 0) {
      pathStore.setPath([
        pathStore.path[0],
        [
          'text',
          planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            pathStore.path.pop();
            pathStore.path[pathStore.path.length - 1][2] = {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            };
            pathStore.path[pathStore.path.length - 1][3] = null;
            navigate(PLAN_PERFORMANCE);
          },
        ],
        [
          'text',
          networkLeakage.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ]);
    } else {
      pathStore.setPath([
        [
          'text',
          planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            pathStore.clearPath();
            navigate(PLAN_PERFORMANCE);
          },
        ],
        [
          'text',
          networkLeakage.titleAndSubtitle.title,
          {
            color: patientAccessTheme.palette.text.highemphasis,
            fontWeight: 600,
          },
        ],
      ]);
    }

    navigate(NETWORK_LEAKAGE, {
      state: {
        networkIndicator:
          employerGroupStore.employerGroupResponseData
            .network_indicator_list[0],
      },
    });
  };

  // const claimsStatusDistribution = () => {
  //   if (pathStore.path.length !== 0) {
  //     pathStore.setPath([
  //       pathStore.path[0],
  //       [
  //         'text',
  //         planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
  //         {
  //           color: patientAccessTheme.palette.primary[500],
  //           fontWeight: 500,
  //         },
  //         () => {
  //           pathStore.path.pop();
  //           pathStore.path[pathStore.path.length - 1][2] = {
  //             color: patientAccessTheme.palette.text.highemphasis,
  //             fontWeight: 600,
  //           };
  //           pathStore.path[pathStore.path.length - 1][3] = null;
  //           history.push(PLAN_PERFORMANCE);
  //         },
  //       ],
  //       [
  //         'text',
  //         planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
  //           .titleAndSubtitle.title,
  //         {
  //           color: patientAccessTheme.palette.text.highemphasis,
  //           fontWeight: 600,
  //         },
  //       ],
  //     ]);
  //   } else {
  //     pathStore.setPath([
  //       [
  //         'text',
  //         planPerformanceMetricsMessages.pageTitles.titleAndSubtitle.title,
  //         {
  //           color: patientAccessTheme.palette.primary[500],
  //           fontWeight: 500,
  //         },
  //         () => {
  //           pathStore.clearPath();
  //           history.push(PLAN_PERFORMANCE);
  //         },
  //       ],
  //       [
  //         'text',
  //         planPerformanceMetricsMessages.pageTitlesofRejectedClaimStatus
  //           .titleAndSubtitle.title,
  //         {
  //           color: patientAccessTheme.palette.text.highemphasis,
  //           fontWeight: 600,
  //         },
  //       ],
  //     ]);
  //   }

  //   history.push(REJECTED_CLAIMS);
  // };

  //---------------------------

  const PlanPerformanceAnalysis = () => {
    return (
      <Grid container style={{ margin: '36px 0px 28px 0px' }}>
        <Grid style={{ width: '1182px' }}>
          <CohortFilterBar />
        </Grid>
        {false && (
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={pageConstants.OVERVIEW_CARDS.TOTAL_ELIGIBLE}
              value={valueWithText(totalEligible?.toString(), 'Employees')}
              rootStyles={{
                width: '176px',
              }}
              showClickHere
              handleClickHere={pushToEnrollemntMetrics}
            />
          </Grid>
        )}
        <Grid style={{ marginRight: '24px' }}>
          <OverviewCard
            title={pageConstants.OVERVIEW_CARDS.TOTAL_ENROLLED}
            value={totalEnrolled?.totalCount}
            isMultiValued={true}
            rightLabelValues={[
              ['Employees', totalEnrolled?.employees],
              ['Dependents', totalEnrolled?.dependents],
            ]}
            rootStyles={{
              width: 'auto',
            }}
            labelsMinWidth="72px"
            showClickHere
            handleClickHere={pushToEnrollemntMetrics}
          />
        </Grid>
        <Grid style={{ marginRight: '24px' }}>
          <OverviewCard
            title={pageConstants.OVERVIEW_CARDS.TOTAL_COST}
            value={totalCost?.totalCost}
            isMultiValued={true}
            rightLabelValues={[
              ['Medical', totalCost?.totalMedical],
              ['Rx', totalCost?.totalRx],
            ]}
            rootStyles={{
              width: '350px',
            }}
          />
        </Grid>
        {/* <Grid item style={{ marginRight: '24px' }}>
          <OverviewCard
            title={pageConstants.OVERVIEW_CARDS.PMPM}
            topLabelValues={getPmpmForCohorts(pmpm, [], [])}
            value={getPmpmValueForCohorts(pmpm, [], [])}
            rootStyles={{
              width: '176px',
            }}
          />
        </Grid>

        <Grid item>
          <OverviewCard
            title={pageConstants.OVERVIEW_CARDS.PEPM}
            topLabelValues={getPepmForCohorts(pepm, [], [])}
            value={getPepmValueForCohorts(pepm, [], [])}
            rootStyles={{
              width: '176px',
            }}
          />
        </Grid> */}
      </Grid>
    );
  };

  const getDataNetwork = () => {
    const colors = [
      '#DADEEF',
      '#B5BEDF',
      '#919DD0',
      '#6C7DC0',
      '#475CB0',
      '#394A8D',
      '#2B376A',
    ];
    const data = networkData?.map(
      (item: AmountRatioAPIResponse, index: number) => {
        return {
          label: item?.network_indicator,
          value: item?.total_paid,
          color: colors[index],
        };
      },
    );
    return data;
  };

  const PlanPerformanceChart = () => {
    return (
      <div>
        <Box>
          <Box>
            <TotalMedicalCost
              medicalCost={getMedicalCost()}
              legend={legend}
              handleRadioButton={handleRadioButton}
              diagnosisType={diagnosisType}
              handleClick={costTrendByMonth}
              isLoading={costTrendLoading}
              title={pageConstants.COST_TREND.TITLE}
              subTitle={pageConstants.COST_TREND.SUB_TITLE}
            />
          </Box>
        </Box>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
          sx={{
            marginTop: '24px',
          }}
        >
          <Box style={{ height: '342px', width: '576px' }}>
            <PieChart
              data={getDataNetwork()}
              messages={
                networkLeakagePageConstants.piChartConstants
                  .inAndOutNetworkMessages
              }
              showClickHere
              handleClick={networkLeakageImpact}
            />
          </Box>

          <Box
            style={{ height: '342px', width: '576px' }}
            sx={{
              marginLeft: '25px',
            }}
          >
            <>
              <BudgetChart
                actualDataForNetClaims={budgetActualData?.totalCost!}
                budgetedDataForNetClaims={budgetActualData?.prevTotalCost!}
              />
            </>
          </Box>
        </Box>
        {/* <Box
          marginTop={'24px'}
          marginBottom={'50px'}
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Box style={{ height: '400px', width: '576px' }}>
            <SunBurstChart
              data={getCostDistrbutionChartData()}
              rxCount={claimCostData?.rx_count!}
              medicalCount={claimCostData?.medical_count!}
              stopLossCount={claimCostData?.stop_loss_count!}
              width={'675px'}
              height={'446px'}
            />
          </Box>

           <Box
            marginLeft={'25px'}
            style={{ height: '400px', width: '477px' }}
            marginBottom={'50px'}
          >
            <ClaimsStatusDistribution
              reversedData={getReversedData()}
              processedData={getProcessedData()}
              rejectedData={getRejectedData()}
              plans={plans}
              width={'477px'}
              height={'446px'}
              widthChart={'380'}
              heightChart={'270'}
              handleOnClick={claimsStatusDistribution}
            />
          </Box> 
        </Box> */}
      </div>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const pathStore = useStores().pathStore;
  const getPath = () => {
    if (location.state !== undefined) {
      return [
        [
          'text',
          'Go Back',
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            navigate(-1);
          },
        ],
      ];
    }
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <div>
      <div className={classes.mainDiv}>
        {getPath().length !== 0 && (
          <Box style={{ marginBottom: '20px' }}>
            <Breadcrumbs itemList={getPath()} />
          </Box>
        )}
        <Box>
          <Box style={{ marginBottom: '50px' }}>
            <>
              <Box style={{ width: '1182px', position: 'relative' }}>
                <PageTitleAndSubTitle
                  title={
                    planPerformanceMetricsMessages.pageTitles.titleAndSubtitle
                      .title
                  }
                  subTitle={
                    planPerformanceMetricsMessages.pageTitles.titleAndSubtitle
                      .subTitle
                  }
                  subTitleStartPeriod={formatDate(
                    aggregationParameter === 'paid'
                      ? paidStartDate
                      : incurredStartDate,
                    'MMMM YYYY',
                  )}
                  subTitleMiddleString={' to '}
                  subTitleEndPeriod={formatDate(
                    aggregationParameter === 'paid'
                      ? paidEndDate
                      : incurredEndDate,
                    'MMMM YYYY',
                  )}
                  showDownloadButton={true}
                  // downloadButtonAction={() => setOpenReportsModal(true)}
                  downloadButtonAction={() => {
                    downloadPdf(
                      'planPerformanceReport',
                      {
                        employer:
                          employerGroupStore?.employerGroupResponseData
                            ?.employer_group_name,
                        member_unique_id_list:
                          cohortDetailsStore.memberUniqueIdList || [],
                        claim_id_list: [],
                        maxClaimDate:
                          employerGroupStore?.employerGroupResponseData
                            ?.max_claim_date,
                        ...payload,
                        networkIndicator:
                          employerGroupStore.employerGroupResponseData
                            .network_indicator_list,
                      },
                      handleOpenSnackBar,
                      'open',
                    );
                    handleOpenSnackBar(
                      snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                      'info',
                      6000,
                    );
                  }}
                  showQueryDataButton={checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )}
                  queryButtonText={
                    cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                      ? 'Edit Cohort'
                      : 'Add Cohort'
                  }
                  queryDataAction={() => {
                    if (
                      checkUserAccess(
                        UserAccessConstants.COHORT_DETAILS,
                        loginPageStore.userResponse.role.name,
                        loginPageStore.userFeatures,
                      )
                    ) {
                      openModal();
                    }
                  }}
                  showAskAi={true}
                  askAiAction={handleAskAi}
                />

                <div
                  style={{
                    position: 'absolute',
                    top: '-2px',
                    left: '158px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Typography
                    fontSize="17px"
                    lineHeight="21px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="semiBold"
                    margin="0px 8px"
                  >
                    {COMMON_TEXTS.FOR}
                  </Typography>
                  <DateFilter />
                </div>

                <TabSelection
                  selectedTabIndex={selectedTabIndex}
                  setSelectedTabIndex={handleSelectedIndex}
                  recommendationFetched={recommendationFetched}
                />
              </Box>
            </>
            {selectedTabIndex === 0 && (
              <>
                <PlanPerformanceAnalysis />
                <PlanPerformanceChart />
              </>
            )}
            {selectedTabIndex === 1 && (
              <div style={{ height: '493px', padding: '20px' }}>
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                />
              </div>
            )}
          </Box>
          <Box id="ScrollElement"></Box>
        </Box>
      </div>
      {pageScrollDown('ScrollElement')}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
        networkIndicator={
          employerGroupStore.employerGroupResponseData.network_indicator_list
        }
      />
    </div>
  );
});

export default PlanPerformance;
